<template>
  <div v-if="errorMessage">{{ errorMessage }}</div>
  <div v-else>
    Creating demo game...
  </div>
</template>
<script>
import GameService from '@/services/GameService.js'

export default {
  props: {
    game_type: { type: String, required: true }
  },
  created() {},
  data() {
    return {
      responseBody: '',
      errorMessage: undefined
    }
  },
  mounted() {
    console.log(`demo Game type: ${this.game_type}`)
    if (this.gameTypeValid) {
      this.createDemoGame()
    }
  },
  computed: {
    gameTypeValid() {
      return true
    }
  },
  methods: {
    createDemoGame: function() {
      GameService.createDemoGame(this.game_type)
        .then(response => {
          console.log(
            `Created demo game successfully: ${JSON.stringify(response.data)}`
          )

          this.responseBody = JSON.stringify(response.data)

          this.$router.push({
            name: 'challenge-play',
            params: {
              code: response.data.gameCode,
              team_id: response.data.team,
              challengeIndex: this.$constants.INTRO_CHALLENGE_INDEX
            }
          })
        })
        .catch(error => {
          console.log(
            'There was a problem creating a demo game: ' + error.message
          )

          this.errorMessage = 'ERROR: Unable to create demo game.'
        })

      //
    }
  }
}
</script>
<style scoped></style>
